import { Banner, Box, BoxProps } from '@biom3/react';
import { useProductsContext } from 'src/context/products-context';
import { useStore } from 'src/context/store-context';
import { useDelayedValue, useTimer } from '../hooks/use-timer';

// time banner will be displayed after open
const BANNER_TIMEOUT = 30000;
// delay before banner is displayed to allow animation
const BANNER_DELAY_TIMEOUT = 300;

export const AllowlistBanner = () => {
  const [{ connected }] = useStore();
  const { storeDiscount } = useProductsContext();

  const initialState = storeDiscount > 0;
  const [display, cancelDisplay] = useTimer(initialState, BANNER_TIMEOUT);

  const visible = useDelayedValue(display, BANNER_DELAY_TIMEOUT);

  if (!display) {
    return null;
  }

  if (storeDiscount > 0 && connected) {
    return (
      <Wrapper display={display} visible={!!visible}>
        <Banner variant="guidance" sx={{ cursor: 'pointer' }} onClick={() => cancelDisplay()}>
          <Banner.Caption sx={{ pointerEvents: 'none' }} weight="bold" size="large">
            {storeDiscount}% off applied!
          </Banner.Caption>
        </Banner>
      </Wrapper>
    );
  }

  return null;
};

const Wrapper = ({
  visible,
  display,
  sx,
  ...props
}: BoxProps & { display: boolean; visible: boolean }) => (
  <Box
    sx={{
      position: 'fixed',
      width: '100%',
      top: '0',
      left: '0',
      zIndex: '20',
      mx: 'auto',
      display: display ? 'block' : 'none',
      opacity: visible ? '1' : '0',
      transitionProperty: 'opacity',
      transitionDuration: 'base.motion.normal.fast.cssDuration',
      transitionTimingFunction: 'base.motion.normal.fast.cssEase',
      ...sx
    }}
    {...props}
  />
);
